import { ref } from 'vue'

export const THEME_STORAGE_KEY = 'web-im:theme'
export const THEMES = ['white', 'warm', 'dark']

const normalizeTheme = (value) => THEMES.includes(value) ? value : 'white'
export const currentTheme = ref(normalizeTheme(document.documentElement.dataset.imTheme))

function applyTheme(value) {
  const theme = normalizeTheme(value)
  document.documentElement.dataset.imTheme = theme
  currentTheme.value = theme
}

export function setTheme(value) {
  applyTheme(value)
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, currentTheme.value)
  } catch (error) {
    // 第三方 iframe 或隐私模式可能禁用存储，本页仍保持当前主题。
  }
}

export function initTheme() {
  applyTheme(document.documentElement.dataset.imTheme)
  window.addEventListener('storage', (event) => {
    if (event.key === THEME_STORAGE_KEY || event.key === null) {
      applyTheme(event.newValue)
    }
  })
}
